import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: null,
};
export const slice = createSlice({
  name: "importantPreview",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setImportantPreview: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setImportantPreview } = slice.actions;

export default slice.reducer;
